// extracted by mini-css-extract-plugin
module.exports = {"currencies_container":"currencies-dropdown_currencies_container__mRlfd","currency":"currencies-dropdown_currency__9uoI0"};